import type { DemoScenarioResolved } from 'tio-data/demo/types';
import type { DemoFixtureIdentity, DemoProductConfig, DemoScenario } from 'tio-employee/demo/types';
import {
  buildWellnessMatchers,
  wellnessCalcFor,
} from 'tio-employee/demo/products/wellness-fixtures';

export function buildWellnessDemo(
  config: Extract<DemoProductConfig, { kind: 'wellness' }>,
  scenario: DemoScenario,
  identity: DemoFixtureIdentity
): DemoScenarioResolved {
  return {
    matchers: buildWellnessMatchers(config.selection, wellnessCalcFor(scenario, identity)),
    seed: [],
  };
}
